import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { RatesApiAdapter } from '../adapters/RatesApiAdapter';

export const useRates = () => {
    const ratesApiAdapter = useMemo(() => {
        const httpClient = createHttpClient(apiClientWH);
        return new RatesApiAdapter(httpClient);
    }, []);

    const { data, isLoading: loading, error } = useQuery({
        queryKey: ['rates'],
        queryFn: async () => {
            const response = await ratesApiAdapter.getRates({
                per_page: 100,
            });
            console.log('Rates API response:', response);
            // Manejar diferentes estructuras de respuesta
            if (Array.isArray(response)) {
                return response;
            }
            return response.data || [];
        },
        staleTime: 5 * 60 * 1000, // 5 minutos
    });

    const rates = data ?? [];

    return {
        rates,
        loading,
        error,
    };
};

